export enum SuspendedPaymentType {
  Pending = 'Pending',
  Voided = 'Voided',
  Posted = 'Posted',
  Returned = 'Returned'
}